import { TextField } from '@mui/material';
import { useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const EmailField = ({ name }) => {
  const { t } = useTranslation();
  const {
    field: { ref, ...fieldRest },
    fieldState: { error },
  } = useController({ name });

  return (
    <TextField
      id={name}
      label={t('forgotPassword.email.label')}
      placeholder={`${t('forgotPassword.email.label')}...`}
      size="small"
      error={!!error}
      helperText={error?.message}
      slotProps={{
        inputLabel: {
          shrink: true,
          style: { fontSize: `calc(0.875rem * 4/3)` },
        },
      }}
      inputRef={ref}
      {...fieldRest}
    />
  );
};
export default EmailField;
